<template>
  <v-card
    :id="`${approvalRequest._id}`"
    class="approval-request-card"
  >
    <v-chip
      class="approval-request-card__chip ma-0 mb-2"
      color="#FF5146"
    />
    <v-card-title
      class="approval-request-card__title pa-0 mb-2"
    >
      Solicitação de {{ requestTitles[approvalRequest.type] }}
    </v-card-title>
    <v-card-text class="pa-0">
      <div
        v-for="[key, value] in Object.entries(formattedRequest)"
        :key="key"
        class="approval-request-card__data"
      >
        <strong class="approval-request-card__data__key">
          {{ key }}:
        </strong>
        {{ value }}
      </div>
    </v-card-text>
    <v-card-actions class="pa-0 ma-0 mt-3">
      <v-btn
        depressed
        dark
        color="#140C22"
        class="approval-request-card__action-btn"
        @click="solveApprovalRequest('APPROVED')"
      >
        Aprovar
      </v-btn>
      <v-btn
        flat
        class="approval-request-card__action-btn px-2"
        @click="solveApprovalRequest('DECLINED')"
      >
        Negar solicitação
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import dayjs from 'dayjs';
import { EventBus } from '@/event-bus.js';
import { everything } from '@sejazipper/layer-api-client';
import { useZipperApi } from '@/composables/useZipperApi';
import { mapGetters } from 'vuex';

const { client } = useZipperApi();

export default {
  props: {
    approvalRequest: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    requestTitles: {
      DISCOUNT: 'alteração de valor',
      STOCK: 'venda com estoque negativo',
    },
  }),
  computed: {
    ...mapGetters(['getCustomer']),
    approvalRequestStore() {
      return this.getCustomer.stores.find((store) => store.id === this.approvalRequest.storeId) || {};
    },
    formattedRequest() {
      const formattedRequest = {
        Vendedor: this.approvalRequest.sellerName,
        Produto: this.approvalRequest.product.description,
        Quantidade: this.approvalRequest.product.quantity || 1,
        'Loja de origem': this.approvalRequestStore.name,
      };

      if (this.approvalRequest.type === 'DISCOUNT') {
        formattedRequest['Valor original do produto'] = this.$options.filters.currency(this.approvalRequest.product.regularPrice);
        formattedRequest.Desconto = this.$options.filters.currency(this.approvalRequest.product.regularPrice - this.approvalRequest.product.discountPrice);
        formattedRequest['Valor final'] = this.$options.filters.currency(this.approvalRequest.product.discountPrice);
      }

      const { createdAt } = this.approvalRequest;
      formattedRequest['Solicitado em'] = `${dayjs(createdAt).format('DD/MM/YYYY')} às ${dayjs(createdAt).format('HH:mm')}`;

      return formattedRequest;
    },
  },
  methods: {
    emitSnackbar(text) {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = text;
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async solveApprovalRequest(status) {
      document.getElementById(this.approvalRequest._id).classList.add('fade-out');

      await client.chain.mutation
        .setApprovalRequestStatus({
          approvalRequestId: this.approvalRequest._id,
          status,
        })
        .get({ ...everything });

      this.emitSnackbar(`Solicitação ${status === 'APPROVED' ? 'aprovada com sucesso' : 'negada'}`);
    },
  },
};
</script>

<style lang="scss">
.approval-request-card {
  display: flex;
  flex-flow: column wrap;
  padding: 20px;
  margin-bottom: 12px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: 7px;
  &__title {
    font: 700 16px/22px 'Nunito Sans';
  }
  &__chip {
    width: 40px;
    height: 6px;
    border-radius: 12px;
  }
  &__data {
    font: 400 14px/19px 'Nunito Sans';
    margin-bottom: 2px;
    &__key {
      font-weight: 600;
    }
  }
  &__action-btn {
    font: 600 14px/102% 'Nunito Sans';
    text-transform: capitalize;
    border-radius: 4px;
    height: 30px;
  }
}

.fade-out {
  transition: 0.5s;
  opacity: 0;
}
</style>
